<div class="card step-card flex flex-column">
  <div>
    <form *ngIf="devicePropertiesForm" [formGroup]="devicePropertiesForm">
      <div class="mb-3 flex flex-column sm:flex-row justify-content-end">
        <button
          [label]="'new.property' | transloco"
          (click)="addProperty()"
          pButton
          pRipple
          icon="pi pi-plus"
          iconPos="left"
          [disabled]="!('ROLE_ADMIN' | userHasRole)"
        ></button>
        <button
          [label]="'misc.copyFromDevice' | transloco"
          (click)="displayCopyFromDevice = true"
          pButton
          pRipple
          class="sm:ml-2 mt-2 sm:mt-0"
          icon="pi pi-copy"
          iconPos="left"
          [disabled]="!('ROLE_ADMIN' | userHasRole)"
        ></button>
      </div>
      <div *ngIf="rowsForm.controls.length > 0" class="my-5" formArrayName="deviceProperties">
        <p-table
          *ngIf="rowsForm"
          [value]="rowsForm.controls"
          [responsive]="true"
          breakpoint="1800px"
          styleClass="p-datatable-striped"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>{{'attribute.name' | transloco}} (*)</th>
              <th>{{'attribute.value' | transloco}}</th>
              <th>{{'model.propertyType' | transloco}} (*)</th>
              <th class="w-8rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-control let-rowIndex="rowIndex">
            <tr [formGroupName]="rowIndex" class="fadein">
              <td>
                <span class="p-column-title">{{'attribute.name' | transloco}} (*)</span>
                <input pInputText type="text" formControlName="name" [readonly]="!('ROLE_ADMIN' | userHasRole)" [ngClass]="!('ROLE_ADMIN' | userHasRole) ? 'p-disabled' : ''">
              </td>
              <td>
                <span class="p-column-title">{{'attribute.value' | transloco}}</span>
                <input pInputText type="text" formControlName="value" [readonly]="!('ROLE_ADMIN' | userHasRole)" [ngClass]="!('ROLE_ADMIN' | userHasRole) ? 'p-disabled' : ''">
              </td>
              <td>
                <span class="p-column-title">{{'model.propertyType' | transloco}} (*)</span>
                <p-dropdown
                  [placeholder]="'select.type' | transloco"
                  [options]="getPropertyTypes(rowIndex)"
                  [disabled]="isDefault(rowIndex) || !('ROLE_ADMIN' | userHasRole)"
                  styleClass="dropdown-width-md"
                  formControlName="propertyType"
                  optionLabel="name"
                ></p-dropdown>
              </td>
              <td class="text-center">
                <span class="p-column-title">{{'common.delete' | transloco}}</span>
                <button
                  *ngIf="'ROLE_ADMIN' | userHasRole"
                  (click)="onRowDelete(rowIndex)"
                  pButton
                  pRipple
                  class="p-button-rounded p-button-text p-button-danger"
                  type="button"
                  icon="pi pi-trash"
                ></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div *ngIf="rowsForm.controls.length === 0" class="font-italic text-center mt-7">
        {{'empty.properties' | transloco}}
      </div>
    </form>
  </div>
  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.previous' | transloco"
          (click)="onPreviousStep()"
          pButton
          pRipple
          class="flex-1 sm:flex-none"
          icon="pi pi-angle-left"
          iconPos="left"
        ></button>
        <button
          [label]="'common.next' | transloco"
          (click)="onNextStep()"
          [disabled]="!devicePropertiesForm?.valid"
          pButton
          pRipple
          class="ml-2 flex-1 sm:flex-none"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="onCancel()"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>
</div>
<app-device-selector
  [(visible)]="displayCopyFromDevice"
  [tenant]="tenant"
  [actionButtons]="copyFromDeviceActions"
></app-device-selector>
